import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Pagination from "react-bootstrap/Pagination";
import "./StockProducts.css";
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  IconButton,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocalStorage } from "../../../CustomHook/useLocalStorage";
import { writeFile, utils } from "xlsx";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PdfIcon from "../../../Assets/Img/pdf17.svg";
import warningIcon from "../../../Assets/Img/warning.svg";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Link } from "react-router-dom";
import StockoutPDF from "./Components/StockoutPdf";
import { Nav } from "react-bootstrap";
import ItemRow from "./Components/ItemRow";
import SpinnerComponent from "../../SpinnerComponent/SpinnerComponent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import api from "../../../utils/axios";


export const StockProducts = (props) => {
  const [tagsAndProductsWithoutTag, setTagsAndProductsWithoutTag] = useState(
    [],
  );
  const [otheTagsAndProductsWithoutTag, setOtherTagsAndProductsWithoutTag] =
    useState([]);
  const [productSelected, setProductSelected] = useState(null);
  const [actualizador, setActualizador] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(8);
  const [warningCaption, setWarningCaption] = useState(false);
  const [expiredCaption, setExpiredCaption] = useState(false);
  const [expiredProductsToPDF, setExpiredProductsToPDF] = useState([]);
  const [zeroStockProducts, setZeroStockProducts] = useState([]);
  const [zeroStockProductsVarios, setZeroStockProductsVarios] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredExpiredProducts, setFilteredExpiredProducts] = useState([]);
  const [filteredZeroStock, setFilteredZeroStock] = useState([]);
  const [allProviders, setAllProviders] = useState([]);
  const [tabSection, setTabSection] = useState("Bioquimicos");

  const [productsToOrder, setProductToOrder] = useState([]);

  const [productToEdit, setProductToEdit] = useState("");
  const [usoSmnalToEdit, setUsoSmnalToEdit] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [expiredCount, setExpiredCount] = useState(0);
  const [warningCount, setWarningCount] = useState(0);

  //----------------------------------------------------------------

  const currentDate = new Date().getTime();
  const thirtyDays = 30 * 24 * 60 * 60 * 1000;
  const periodToExpireDate = currentDate + thirtyDays;

  const thirtyDaysDate = new Date(periodToExpireDate);

  useEffect(() => {
    async function getDataProducts() {
      setIsLoading(true);
      // console.log("[getDataProducts] INICIADO");

      sessionStorage.setItem("QuiebreStock", []);

      const {
        data: { tags: allTags },
      } = await api.get("/tags");

      // console.log("[getDataProducts] Tags cargados:", allTags);

      let tagsAndProductsWithoutTagArr = [];

      if (tabSection === "Bioquimicos") {
        let products = [];

        allTags
          .find((tag) => tag.name === "-")
          .products.forEach((product) => products.push(product));
        allTags
          .filter((tag) => tag.isProducts)
          .forEach((tag) =>
            tag.products.forEach((product) => products.push(product)),
          );
        // console.log("[Bioquimicos] Total productos:", products.length);

        const productToExpire = products.some((product) => {
          return product?.lots?.some(
            (lot) => new Date(lot.expireDate).getTime() <= periodToExpireDate,
          );
        });

        const productExpired = products.some((product) => {
          return product?.lots?.some(
            (lot) => new Date(lot.expireDate).getTime() <= currentDate,
          );
        });
        // console.log("[Bioquimicos] ¿Hay productos vencidos?:", productExpired);

        //mostrar contador en el home
        const totalExpired = products.reduce((acc, product) => {
          const expiredLots = product?.lots?.filter(
            (lot) => new Date(lot.expireDate).getTime() <= currentDate,
          );
          return acc + (expiredLots ? expiredLots.length : 0);
        }, 0);

        const totalToExpire = products.reduce((acc, product) => {
          const warningLots = product?.lots?.filter(
            (lot) =>
              new Date(lot.expireDate).getTime() > currentDate &&
              new Date(lot.expireDate).getTime() <= periodToExpireDate,
          );
          return acc + (warningLots ? warningLots.length : 0);
        }, 0);

        setExpiredCount(totalExpired);
        setWarningCount(totalToExpire);
        ////////

        const productsExpiredToPdf = products.filter((product) => {
          return (
            product?.quantity > 0 &&
            new Date(product.expireDate).getTime() <= currentDate
          );
        });
        // console.log("[Bioquimicos] Para PDF (vencidos):", productsExpiredToPdf);
        setExpiredProductsToPDF(productsExpiredToPdf);
        setWarningCaption(productToExpire);
        setExpiredCaption(productExpired);

        tagsAndProductsWithoutTagArr = [
          ...allTags.filter((tag) => tag.name !== "-" && tag.isProducts),
          ...allTags.find((tag) => tag.name === "-").products,
        ];
      } else {
        tagsAndProductsWithoutTagArr = [
          ...allTags.filter((tag) => tag.name !== "-" && !tag.isProducts),
          ...allTags.find((tag) => tag.name === "-").otherProducts,
        ];

        setWarningCaption(false);
        setExpiredCaption(false);
      }

      setTagsAndProductsWithoutTag(tagsAndProductsWithoutTagArr);
      const sinStockProducts = tagsAndProductsWithoutTagArr.filter(
        (product) => product.quantity < product.usoSmnal,
      );
      // console.log(
      //   "[Stock] Bioquímicos sin stock mínimo:",
      //   sinStockProducts.length,
      //   sinStockProducts,
      // );

      const sinStockProductsVarios = tagsAndProductsWithoutTagArr.filter(
        (otherProduct) => otherProduct.quantity < otherProduct.usoSmnal,
      );
      // console.log(
      //   "[Stock] Varios sin stock mínimo:",
      //   sinStockProductsVarios.length,
      //   sinStockProductsVarios,
      // );

      setZeroStockProducts(sinStockProducts);
      setZeroStockProductsVarios(sinStockProductsVarios);

      if (sinStockProducts.length > 0 || sinStockProductsVarios.length > 0) {
        // console.log("[SessionStorage] Guardando productos sin stock");

        window.sessionStorage.setItem(
          "QuiebreStock",
          JSON.stringify(sinStockProducts),
        );
        window.sessionStorage.setItem(
          "QuiebreStockVarios",
          JSON.stringify(sinStockProductsVarios),
        );
      }
      setIsLoading(false);
    }

    getDataProducts();
  }, [actualizador]);

  const loadProviders = async () => {
    if (allProviders.length > 0) return;

    const result = await api.get("/proveedor");
    setAllProviders(result.data.provider || []);
  };

  useEffect(() => {
    const productsToOrderData = [];

    tagsAndProductsWithoutTag.forEach((product) => {
      if (product.provider._id !== selectedProvider) return;

      if (tabSection === "Bioquimicos") {
        if (
          product.quantity < product.usoSmnal ||
          product?.products?.some((subProduct) =>
            subProduct?.lots?.some(
              (lot) => new Date(lot.expireDate) < new Date(),
            ),
          ) ||
          product?.lots?.some((lot) => new Date(lot.expireDate) < new Date())
        ) {
          function formatProduct(subProduct, lot, tag) {
            const quantity = tag?.quantity || subProduct?.quantity;
            const usoSmnal = tag?.usoSmnal || subProduct?.usoSmnal;
            return {
              product: {
                ...subProduct,
                usoSmnal, // Para mostrar faltante en PDF
              },

              lot: {
                ...lot,
                acquireDate: `${new Date(lot.acquireDate).getDate()}/${new Date(lot.acquireDate).getMonth() + 1}/${new Date(
                  lot.acquireDate,
                ).getFullYear()}`,
                expireDate: `${new Date(lot.expireDate).getDate()}/${new Date(lot.expireDate).getMonth() + 1}/${new Date(lot.expireDate).getFullYear()}`,
                state:
                  quantity < usoSmnal
                    ? "SIN STOCK"
                    : new Date(lot.expireDate) < new Date()
                      ? "VENCIDO"
                      : "-",
              },
            };
          }

          if (product.hasOwnProperty("isProducts")) {
            // Es tag
            product.products.forEach((subProduct) =>
              subProduct.lots.forEach((lot) =>
                productsToOrderData.push(
                  formatProduct(subProduct, lot, product),
                ),
              ),
            );
          } else {
            // Es producto bioquímico
            product.lots.forEach((lot) =>
              productsToOrderData.push(formatProduct(product, lot)),
            );
          }
        }
      } else {
        if (product.quantity < product.usoSmnal) {
          productsToOrderData.push({
            product: {
              ...product,
              state: "SIN STOCK",
            },
          });
        }
      }
      const criticalProducts = {
        vencidos: productsExpiredToPdf,
        sinStock: sinStockProducts,
        sinStockVarios: sinStockProductsVarios,
      };
      // console.log("[Critical] Estado crítico productos:", criticalProducts);
    });

    // console.log(
    //   "[OrdenCompra] Productos a ordenar:",
    //   productsToOrderData.length,
    //   productsToOrderData,
    // );

    setProductToOrder(productsToOrderData);
  }, [tagsAndProductsWithoutTag, selectedProvider]);

  const handleProviderChange = (event) => {
    const provider = event.target.value;
    setSelectedProvider(provider);
  };

  useEffect(() => {
    // Filtro para PDF
    const filteredProviderExpiredProducts = expiredProductsToPDF.filter(
      (product) => product.provider._id === selectedProvider,
    );

    setFilteredExpiredProducts(filteredProviderExpiredProducts);

    const filteredProviderZeroStockProducts = zeroStockProducts.filter(
      (product) => product.provider._id === selectedProvider,
    );

    setFilteredZeroStock(filteredProviderZeroStockProducts);
  }, [selectedProvider]);

  // ------------ MODAL ----------------

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  //------------ BUSQUEDA Y PAGINACION-----------

  useEffect(() => {
    setCurrentPage(1); // Reiniciar la página a 1 cada vez que cambie el término de búsqueda
  }, [searchTerm]);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const debounce = (callback, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  const handleFilterChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const delayedHandleFilterChange = debounce(handleFilterChange, 500);

  const tagsAndProductsWithoutTagFiltered = tagsAndProductsWithoutTag.filter(
    (product) => {
      // Aplicar filtro por nombre, fecha de vencimiento, etc.
      return (
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        new Date(product.expireDate)
          .toLocaleDateString("es-AR")
          .includes(searchTerm.toLowerCase())
        // Agrega otros criterios de búsqueda si es necesario
      );
    },
  );

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = tagsAndProductsWithoutTagFiltered.slice(
    indexOfFirstProduct,
    indexOfLastProduct,
  );
  const totalPages = Math.ceil(
    tagsAndProductsWithoutTagFiltered.length / productsPerPage,
  );
  const pagesToShow = 5;

  const renderPaginationItems = () => {
    const paginationItems = [];
    let startPage = Math.max(currentPage - Math.floor(pagesToShow / 2), 1);
    let endPage = Math.min(startPage + pagesToShow - 1, totalPages);
    if (endPage - startPage + 1 < pagesToShow && startPage > 1) {
      startPage = Math.max(endPage - pagesToShow + 1, 1);
    }
    for (let page = startPage; page <= endPage; page++) {
      paginationItems.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </Pagination.Item>,
      );
    }

    return paginationItems;
  };

  const updateProduct = async (product, usoSmnal) => {
    if (product.hasOwnProperty("tag")) {
      // Si es producto
      if (tabSection === "Bioquimicos") {

        await api.put(`/productos/edit/${product._id}`, {
          usoSmnal: usoSmnal,
        });

      } else {

        await api.put(`/otros_productos/edit/${product._id}`, {
          usoSmnal: usoSmnal,
        });

      }
    } else {
      // Si es tag

      await api.put(`/tags/edit/${product._id}`, {
        usoSmnal: usoSmnal,
      });
      
    }

    setActualizador(actualizador + 1);
  };

  const handleTabChange = (section) => {
    if (section === null) return;
    setTabSection(section);
    handlePageChange(1);
    setSearchTerm("");
    setActualizador(actualizador + 1);
  };
  // console.log(productsToOrder)
  //-----------------GENERAR-ORDEN-COMPRA---------------

  const generateOrder = () => {
    if (!selectedProvider) {
      window.alert(
        "Por favor, selecciona un proveedor antes de generar la orden de compra",
      );
      return;
    }

    if (productsToOrder.length > 0) {
      const productsData = [];

      if (tabSection === "Bioquimicos") {
        productsToOrder.map(({ product, lot }) => {
          const restProduct =
            product.usoSmnal - product.quantity > 0
              ? product.usoSmnal - product.quantity
              : 0;

          productsData.push({
            "Código del Producto": product.code,
            Nombre: product.name,
            Proveedor: product.provider.name,
            Marca: product.brand,
            "Tipo de Unidad": product.unitType.name,
            Nbu: product.ubn,
            "Código del Lote": lot.lotNumber,
            "Cantidad de Lotes": lot.lotQuantity,
            "Fecha Ingreso": lot.acquireDate,
            "Fecha Vencimiento": lot.expireDate,
            Cantidad: lot.quantity,
            Estado: lot.state,
            Faltantes:
              restProduct > 0
                ? `Faltan ${restProduct} productos`
                : "Stock suficiente",
          });
        });
      } else {
        productsToOrder.map(({ product }) => {
          const restProduct =
            product.usoSmnal - product.quantity > 0
              ? product.usoSmnal - product.quantity
              : 0;

          productsData.push({
            "Código del Producto": product?.code || "-",
            Nombre: product.name,
            Proveedor: product.provider.name,
            Categoría: product.category.name,
            Cantidad: product.quantity,
            Estado: product.state,
            Faltantes:
              restProduct > 0
                ? `Faltan ${restProduct} productos`
                : "Stock suficiente",
          });
        });
      }

      // Crear el objeto worksheet con los datos de los productos
      const worksheet = utils.json_to_sheet(productsData);

      // Crear el objeto workbook y asignar el worksheet
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "Orden de Compra");

      // Guardar el archivo Excel
      writeFile(workbook, `orden_compra_${selectedProvider}.xlsx`);
    } else {
      window.alert("No se requiere generar una orden de compra");
    }
  };

  function isEven(n) {
    return n % 2 == 0;
  }

  return (
    <>
      {props.resumen ? (
        <>
          <div
            className="header-stock-new"
            style={{
              maxWidth: "95%",
              flexDirection: "column",
            }}
          >
            <Card style={{ border: "1px solid #ecf2f1", borderRadius: "8px" }}>
              <Card.Header
                className=""
                style={{
                  fontSize: "24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingTop: "16px",
                  paddingBottom: "24px",
                  height: "64px",
                  backgroundColor: "#fff",
                }}
              >
                <span>Quiebre Stock</span>

                <div
                  style={{ display: "flex", gap: "12px", alignItems: "center" }}
                >
                  {expiredCount > 0 && (
                    <span
                      style={{
                        background: "#fff",
                        border: "1px solid #e32f2fff",
                        color: "#e32f2fff",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontWeight: "normal",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px",
                      }}
                    >
                      <ErrorOutlineIcon
                        style={{ fontSize: "16px", marginRight: "6px" }}
                      />
                      {expiredCount} productos vencido
                      {expiredCount !== 1 ? "s" : ""}
                    </span>
                  )}

                  {warningCount > 0 && (
                    <span
                      style={{
                        background: "#fff",
                        border: "1px solid #dc9c05ff",
                        color: "#dc9c05ff",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontWeight: "normal",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px",
                      }}
                    >
                      <ErrorOutlineIcon
                        style={{ fontSize: "16px", marginRight: "6px" }}
                      />
                      {warningCount} por vencer
                    </span>
                  )}
                </div>
              </Card.Header>

              <ToggleButtonGroup
                value={tabSection}
                exclusive
                onChange={(event, newTab) => handleTabChange(newTab)}
                aria-label="text alignment"
                sx={{
                  marginLeft: "10px",
                  marginTop: "20px",
                }}
              >
                <ToggleButton
                  value="Bioquimicos"
                  aria-label="Bioquimicos"
                  className={tabSection === "Bioquimicos" ? "active" : ""}
                  sx={{
                    width: "149px",
                    height: "40px",
                    flexShrink: 0,
                  }}
                >
                  Bioquímicos
                </ToggleButton>
                <ToggleButton
                  value="Varios"
                  aria-label="Varios"
                  className={tabSection === "Varios" ? "active" : ""}
                  sx={{
                    width: "149px",
                    height: "40px",
                    flexShrink: 0,
                  }}
                >
                  Varios
                </ToggleButton>
              </ToggleButtonGroup>
              {!sessionStorage.getItem("QuiebreStock") ? (
                <Card.Body>
                  <Card.Title className="ct-main-stock">Hay stock</Card.Title>
                  <Card.Text></Card.Text>
                </Card.Body>
              ) : (
                <Card.Body
                  className="cb-main-stock, table-container"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <Card.Title style={{ fontSize: "18px", fontWeight: "400" }}>
                    Los siguientes productos no tienen stock mínimo
                  </Card.Title>

                  <Card.Subtitle
                    className="ct-main-stock"
                    style={{
                      margin: "16px 0 20px",
                      width: "100%",
                    }}
                  >
                    {JSON.parse(sessionStorage.getItem("QuiebreStock")).map(
                      (product, index) => (
                        <div className="ct-stock-min">
                          <p className="ct-stock-min" key={index}>
                            <span className="product-name">
                              {product.name || "Sin nombre"}:{" "}
                            </span>
                          </p>
                          <p
                            className=""
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "justify-beetween",
                              textAlign: "end",
                              width: "100%",
                              paddingRight: "16px",
                            }}
                          >
                            <span className="product-quantity">
                              {" "}
                              {product.quantity || 0}
                            </span>
                          </p>
                        </div>
                      ),
                    )}
                  </Card.Subtitle>
                  <Link
                    className="btn-main btn-primary"
                    to={"/productos/stock"}
                  >
                    Ver quiebre de stock
                    <ArrowForwardIcon style={{ width: "20px" }} />
                  </Link>
                  {/* <Link
										className="btn btn-primary"
										to={"/provider-order"}
									>
										Generar Pedido
									</Link> */}
                </Card.Body>
              )}
            </Card>
          </div>
        </>
      ) : (
        <>
          <div className="main-container">
            <div className="header--container">
              <div className="header-row-stock">
                <h1 className="title--header">Quiebre Stock</h1>
                <Form.Group>
                  <Form.Control
                    className="stock-search"
                    type="search"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      delayedHandleFilterChange(e);
                    }}
                  />
                </Form.Group>
              </div>
              <Form className="stock-form">
                <div className="stock-select-warning">
                  {warningCaption && (
                    <p className="notify-warning ">
                      <ErrorOutlineIcon
                        style={{
                          width: "20px",
                          marginRight: "6px",
                          color: "#dc9c05ff",
                        }}
                      />
                      Hay {warningCount} productos próximos a vencer
                    </p>
                  )}

                  {expiredCaption && (
                    <p className="notify-danger">
                      <ErrorOutlineIcon
                        style={{
                          width: "20px",
                          marginRight: "6px",
                          color: "#e32f2fff",
                        }}
                      />
                      Hay {expiredCount} productos vencido
                      {expiredCount !== 1 ? "s" : ""}
                    </p>
                  )}
                </div>
              </Form>
            </div>
            <div className="card--container">
              <div className="card--header--row">
                <ToggleButtonGroup
                  value={tabSection}
                  exclusive
                  onChange={(event, newTab) => handleTabChange(newTab)}
                  aria-label="text alignment"
                >
                  <ToggleButton
                    value="Bioquimicos"
                    aria-label="Bioquimicos"
                    className={tabSection === "Bioquimicos" ? "active" : ""}
                    sx={{
                      width: "149px",
                      height: "40px",
                      flexShrink: 0,
                    }}
                  >
                    Bioquímicos
                  </ToggleButton>
                  <ToggleButton
                    value="Varios"
                    aria-label="Varios"
                    className={tabSection === "Varios" ? "active" : ""}
                    sx={{
                      width: "149px",
                      height: "40px",
                      flexShrink: 0,
                    }}
                  >
                    Varios
                  </ToggleButton>
                </ToggleButtonGroup>

                <div className="stock-select">
                  <Form.Select
                    className="select-stock-provider"
                    value={selectedProvider}
                    onFocus={loadProviders}
                    onClick={loadProviders}
                    onChange={handleProviderChange}
                  >
                    <option value="">Seleccionar proveedor</option>
                    {allProviders.map((provider) => (
                      <option key={provider._id} value={provider._id}>
                        {provider.name}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>


              {/* TABLA */}
              <div className="table-container">
                <SpinnerComponent
                  isLoading={isLoading}
                  alternative={<div>No se encontraron productos</div>}
                  isAlternative={!currentProducts.length}
                >
                  <Table responsive className="">
                    <thead responsive>
                      <tr>
                        <th>Nombre</th>
                        <th>Proveedor</th>
                        <th>Cantidad</th>
                        <th>Stock Mínimo</th>

                        <th>Estado</th>
                        <th>
                          Faltantes
                          <Tooltip
                            title={
                              <span style={{ fontSize: "14px" }}>
                                Cantidad de productos necesarios para completar
                                el stock mínimo
                              </span>
                            }
                            arrow
                          >
                            <IconButton
                              size="small"
                              style={{ marginLeft: "5px", color: "white" }}
                            >
                              <InfoOutlinedIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </th>
                        <th>Editar</th>
                        <th>Ver más</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentProducts.map((product, i) => {
                        return (
                          <ItemRow
                            backgroundColorClass={
                              isEven(i) ? "" : "backgound-veryLight"
                            }
                            item={product}
                            key={product._id}
                            setItemToEdit={setProductToEdit}
                            setUsoSmnalToEdit={setUsoSmnalToEdit}
                            setShowModal={setShowModal}
                            isOtherProducts={tabSection !== "Bioquimicos"}
                          />
                        );
                      })}
                    </tbody>
                  </Table>
                </SpinnerComponent>
              </div>


            </div>
            <Pagination className="pagination-all-tag">
              <Pagination.Prev
                onClick={() =>
                  setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)
                }
                disabled={currentPage === 1}
              />
              {renderPaginationItems()}
              <Pagination.Next
                onClick={() =>
                  setCurrentPage(
                    currentPage < totalPages ? currentPage + 1 : totalPages,
                  )
                }
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>

          {/*Modal para modificación quiebre para productos*/}
          <Modal show={showModal} onHide={handleClose} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>Editar Stock Mínimo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Stock Mínimo</Form.Label>
                  <Form.Control
                    type="number"
                    value={usoSmnalToEdit}
                    onChange={(e) => {
                      setUsoSmnalToEdit(e.target.value);
                    }}
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cerrar
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  updateProduct(productToEdit, usoSmnalToEdit);
                  handleClose();
                }}
              >
                Guardar cambios
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Botonera inferior derecha */}
          <div className="container-btn-footer">
            <div className="button-footer">
              <Tooltip title="Generar excel" arrow>
                <Button
                  className="btn--primary--abm btn btn--primary"
                  onClick={() => {
                    if (!selectedProvider) {
                      window.alert(
                        "Por favor, selecciona un proveedor antes de generar el Excel",
                      );
                    } else {
                      generateOrder();
                    }
                  }}
                >
                  <DescriptionOutlinedIcon />
                </Button>
              </Tooltip>
              <Tooltip title="Exportar PDF" arrow>
                <Button
                  className="btn--primary--abm btn btn--primary"
                  onClick={() => {
                    if (!selectedProvider) {
                      window.alert(
                        "Por favor, selecciona un proveedor antes de generar el PDF",
                      );
                    }
                  }}
                  disabled={!selectedProvider}
                >
                  <PDFDownloadLink
                    document={
                      <StockoutPDF
                        productsToOrder={productsToOrder}
                        isOtherProducts={tabSection !== "Bioquimicos"}
                      />
                    }
                    fileName="QuiebreStock"
                  >
                    <img
                      className="icon_buttons"
                      src={PdfIcon}
                      alt="camera capture"
                    />
                  </PDFDownloadLink>
                </Button>
              </Tooltip>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StockProducts;
